/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChameleonMatchType {
  USDOT = 'usdot',
  CARRIER_NAME = 'carrier_name',
  PHONE = 'phone',
  EMAIL = 'email',
  SSN = 'ssn',
  EIN = 'ein',
  ADDRESS = 'address',
  DBA_NAME = 'dba_name',
  OWNER_NAME = 'owner_name',
}
